import { BadgeSeverity } from '@common/dsfr-ui';
import { OrganismeStatutType } from '@common/services';
import { ORGANISME_STATUT_TEXTS } from './texts';

export const ORGANISME_STATUS_STYLES: Record<OrganismeStatutType, { text: string; color: string; }> = {
  [OrganismeStatutType.ATTENTE_HABILITATION]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.ATTENTE_HABILITATION],
    color: '#E1000F',
  },
  [OrganismeStatutType.CREATION]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.CREATION],
    color: '#3333bb',
  },
  [OrganismeStatutType.MAJ_ANNUELLE]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.MAJ_ANNUELLE],
    color: '#3333bb',
  },
  [OrganismeStatutType.VALIDE]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.VALIDE],
    color: '#159a3c',
  },
  [OrganismeStatutType.DEMANDE_INFORMATION]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.DEMANDE_INFORMATION],
    color: '#3333bb',
  },
  [OrganismeStatutType.REFUS]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.REFUS],
    color: '#E1000F',
  },
  [OrganismeStatutType.MAJ_DOCUMENTS]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.MAJ_DOCUMENTS],
    color: '#3333bb',
  },
  [OrganismeStatutType.DEVALIDE]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.DEVALIDE],
    color: '#E1000F',
  },
  [OrganismeStatutType.DEPOT_BLOQUE]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.DEPOT_BLOQUE],
    color: '#E1000F',
  },
  [OrganismeStatutType.ATTENTE_REVALIDATION_HABILITATION]: {
    text: ORGANISME_STATUT_TEXTS[OrganismeStatutType.ATTENTE_REVALIDATION_HABILITATION],
    color: '#E1000F',
  },
};

export function getBadgeSeverityByStatutOrganisme(statut: OrganismeStatutType)
  : BadgeSeverity {
  switch (statut) {
    case OrganismeStatutType.ATTENTE_HABILITATION:
    case OrganismeStatutType.REFUS:
    case OrganismeStatutType.DEVALIDE:
    case OrganismeStatutType.DEPOT_BLOQUE:
    case OrganismeStatutType.ATTENTE_REVALIDATION_HABILITATION:
      return BadgeSeverity.ERROR;
    case OrganismeStatutType.VALIDE:
      return BadgeSeverity.SUCCESS;
    default:
      return BadgeSeverity.INFO;
  }
}